<div class="ubc-chart" *ngIf="data">
  <div #ubcHost [id]="$any(data).widgetId" class="ubc-chart-host" [style.height]="hostHeight"></div>
</div>
